import React from 'react';

import Layout from 'components/Layout';
import SEO from 'components/SEO';
import Privacy from 'components/Commerce';

const CommercePage: React.FC = () => {
  return (
    <Layout>
      <SEO title="特定商取引法に基づく表示" />
      <Privacy />
    </Layout>
  );
};

export default CommercePage;
